
import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from './pages/Dashboard';
import Login from './pages/auth/Login';
import { useSelector } from "react-redux";
import Index from './pages/users/Index';
import Categories from './pages/products/Categories';
import EditCategory from './pages/products/EditCategory';
import AddCategory from './pages/products/AddCategory';
import NotFound from './pages/errors/NotFound';
import Blogs from './pages/blogs/Blogs';
import AddBlog from './pages/blogs/AddBlog';
import EditBlog from './pages/blogs/EditBlog';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'react-quill/dist/quill.snow.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-tagsinput/react-tagsinput.css';
import './App.css';
import Coupon from './pages/coupon/Coupons';
import AddCoupon from './pages/coupon/AddCoupon';
import EditCoupon from './pages/coupon/EditCoupon';
import Products from './pages/products/Products';
import AddProduct from './pages/products/AddProduct';
import EditProduct from './pages/products/EditProduct';
import { checkToken } from './utils/tokenHelper';
import Shippings from './pages/shipping/Shippings';
import CreateShippingMethod from './pages/shipping/CreateShippingMethod';
import EditShippingMethod from './pages/shipping/EditShippingMethod';
import CreateShippingZone from './pages/shipping/CreateShippingZone';
import EditShippingZone from './pages/shipping/EditShippingZone';
import CreateShippingRate from './pages/shipping/CreateShippingRate';
import EditShippingRate from './pages/shipping/EditShippingRate';
import Orders from './pages/orders/Orders';
import Testimonials from './pages/testimonials/Testimonials';
import AddTestimonial from './pages/testimonials/AddTestimonial';
import EditTestimonial from './pages/testimonials/EditTestimonial';
import OrderDetails from './pages/orders/OrderDetails';

function App() {
  const user = useSelector((state) => state.LoginReducer.authData);
  useEffect(() => {
    checkToken();
  }, []);
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={user ? <Navigate to="/dashboard" /> : <Navigate to="/login" />}/>
        <Route path="/dashboard" element={user ? <Dashboard /> : <Navigate to="/login" />}/>
        <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login /> } />
        <Route path="/users" element={user ? <Index /> :  <Navigate to="/login" /> } />
        
        <Route path="/categories" element={user ? <Categories /> :  <Navigate to="/login" /> } />
        <Route path="/categories/create-category" element={user ? <AddCategory /> :  <Navigate to="/login" /> } />
        <Route path="/categories/edit-category/:id" element={user ? <EditCategory /> :  <Navigate to="/login" /> } />

        <Route path="/blogs" element={user ? <Blogs /> :  <Navigate to="/login" /> } />
        <Route path="/blogs/create-blog" element={user ? <AddBlog /> :  <Navigate to="/login" /> } />
        <Route path="/blogs/edit-blog/:id" element={user ? <EditBlog /> :  <Navigate to="/login" /> } />

        <Route path="/coupons" element={user ? <Coupon /> :  <Navigate to="/login" /> } />
        <Route path="/coupons/create-coupon" element={user ? <AddCoupon /> :  <Navigate to="/login" /> } />
        <Route path="/coupons/edit-coupon/:id" element={user ? <EditCoupon /> :  <Navigate to="/login" /> } />

        <Route path="/products" element={user ? <Products /> :  <Navigate to="/login" /> } />
        <Route path="/products/create-product" element={user ? <AddProduct /> :  <Navigate to="/login" /> } />
        <Route path="/products/edit-product/:id" element={user ? <EditProduct /> :  <Navigate to="/login" /> } />
        
        <Route path="/shippings" element={user ? <Shippings /> :  <Navigate to="/login" />} />

        <Route path="/shippings/create-shipping-method" element={user ? <CreateShippingMethod /> :  <Navigate to="/login" />} />
        <Route path="/shippings/edit-shipping-method/:id" element={user ? <EditShippingMethod /> :  <Navigate to="/login" />} />

        <Route path="/shippings/create-shipping-zone" element={user ? <CreateShippingZone /> :  <Navigate to="/login" />} />
        <Route path="/shippings/edit-shipping-zone/:id" element={user ? <EditShippingZone /> :  <Navigate to="/login" />} />

        <Route path="/shippings/create-shipping-rate" element={user ? <CreateShippingRate /> :  <Navigate to="/login" />} />
        <Route path="/shippings/edit-shipping-rate/:id" element={user ? <EditShippingRate /> :  <Navigate to="/login" />} />

        <Route path="/orders" element={user ? <Orders /> :  <Navigate to="/login" />} />
        <Route path="/orders/details/:id" element={user ? <OrderDetails /> :  <Navigate to="/login" />} />

        <Route path="/testimonials" element={user ? <Testimonials /> :  <Navigate to="/login" /> } />
        <Route path="/testimonials/create-testimonial" element={user ? <AddTestimonial /> :  <Navigate to="/login" /> } />
        <Route path="/testimonials/edit-testimonial/:id" element={user ? <EditTestimonial /> :  <Navigate to="/login" /> } />

        <Route path='*' Component={NotFound} />
      </Routes>
    </div>
  );
}

export default App;
